var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "d61cc166762f074d7bdb886b0c6fa00b7e4ad26c"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["dubbot-react@dubbot-5f"] = {
  id: "d61cc166762f074d7bdb886b0c6fa00b7e4ad26c"
};